const sl = {
  seo: {
    domov: {
      title: 'Judo klub Izola | Judo Obala – Izola, Koper, Ankaran, Portorož',
      description: 'Judo klub Izola – Judo šola Iztoka Babiča. Judo za otroke in mlade na slovenski Obali: Izola, Koper, Ankaran, Portorož. Več kot 30 let tradicije in olimpijska prvakinja Andreja Leški.',
      keywords: 'judo obala, judo koper, judo portorož, judo ankaran, judo izola, judo klub izola, judo šola, judo za otroke, Iztok Babič, Andreja Leški',
    },
    onas: {
      title: 'O nas | Judo klub Izola – Judo šola Iztoka Babiča',
      description: 'Zgodba Judo kluba Izola: več kot 30 let juda na Obali, judo kampi, literatura in pot do olimpijske zlate medalje Andreje Leški v Parizu 2024.',
      keywords: 'judo izola zgodovina, judo šola Iztoka Babiča, judo kampi izola, Andreja Leški, judo obala, judo koper',
    },
    galerija: {
      title: 'Galerija | Judo klub Izola',
      description: 'Foto utrinki Judo kluba Izola: treningi, tekmovanja, judo kampi in dogodki z olimpijsko prvakinjo Andrejo Leški.',
      keywords: 'judo izola galerija, judo kampi, judo obala foto, Andreja Leški',
    },
    kontakt: {
      title: 'Urnik in kontakt | Judo klub Izola',
      description: 'Urnik treningov in kontakt Judo kluba Izola. Treningi v telovadnici OŠ Dante Alighieri v Izoli. Judo za dečke in deklice na Obali.',
      keywords: 'judo izola urnik, judo izola kontakt, judo obala, judo koper, judo ankaran, judo portorož, vpis judo 2026',
    },
    strokovna: {
      title: 'Strokovna znanja | Judo klub Izola',
      description: 'Predavanja, strokovni članki in zgodovinski pogledi trenerja Iztoka Babiča o judu, tekmovalni filozofiji športa in olimpijski tradiciji.',
      keywords: 'judo strokovna znanja, Iztok Babič predavanje, judo teorija, zgodovina športa, olimpijske igre, judo obala',
    },
    kampi: {
      title: 'Kampi in prireditve | Judo klub Izola',
      description: 'Poletni judo kampi v Izoli, mednarodno povezovanje in Evropski mladinski judo pokal v Areni Bonifika. Judo klub Izola.',
      keywords: 'judo kampi izola, poletni judo kamp, evropski mladinski pokal, Arena Bonifika, judo obala, judo koper',
    },
  },
  nav: {
    links: [
      { name: 'Domov', path: '/' },
      { name: 'O nas', path: '/o-nas' },
      { name: 'Galerija', path: '/galerija' },
      { name: 'Strokovna znanja', path: '/strokovna-znanja' },
      { name: 'Kampi in prireditve', path: '/kampi-in-prireditve' },
      { name: 'Urnik in kontakt', path: '/kontakt' },
    ],
  },
  footer: {
    country: 'Slovenija',
    desc: 'Tradicija, disciplina in odličnost v judu. Judo Klub Izola je dom za vse generacije judoistov.',
    navTitle: 'Navigacija',
    contactTitle: 'Kontakt',
    address: 'OŠ Dante Alighieri, Izola',
    rights: 'Vse pravice pridržane.',
    school: 'Judo šola Iztoka Babiča',
    areas: 'Judo za otroke in mlade na slovenski Obali – Izola, Koper, Ankaran in Portorož.',
  },
  domov: {
    hero: {
      badge: 'Dobrodošli',
      sub: 'Tradicija, ustvarjalnost in odličnost v judu',
      ctaJoin: 'Pridruži se nam',
      ctaNews: 'Preberi novice',
    },
    project: {
      label: 'Aktualni projekt',
      title: 'Projekt Fit in vključeni',
      introBefore: 'Judo klub Izola sodeluje kot partner v projektu ',
      introHighlight: 'Fit in vključeni',
      introAfter: ', ki je sofinanciran v okviru Javnega razpisa za razvoj in profesionalizacijo NVO in prostovoljstva 2025. Projekt se financira iz Sklada za razvoj nevladnih organizacij.',
      bullets: [
        'Redna vadba otrok in mladih',
        'Promocija juda na OŠ',
        'Vključevanje otrok priseljencev',
        'Individualno mentorstvo',
        'Strokovni razvoj trenerjev',
        'Zdrav življenjski slog',
      ],
      note: 'S projektom povečujemo dostopnost športa, spodbujamo vključevanje otrok ter prispevamo k razvoju kakovostnih športnih programov v lokalnem okolju.',
    },
    newsLabel: 'Novice',
    news1: {
      title: 'Olimpijska prvakinja Andrea Leški v Judo klubu Izola – Trening, ki ga ne pozabiš!',
      p1: 'V Judo klubu Izola smo doživeli izjemen športni trenutek: obiskala nas je olimpijska prvakinja Andrea Leški in vodila poseben trening za naše člane. Trening je bil energičen, motivacijski in poln vrhunskih nasvetov iz prve roke – še posebej so ga z navdušenjem doživeli mladostniki, ki so dobili priložnost trenirati z najboljšo in izkusiti, kako razmišlja ter deluje olimpijska zmagovalka.',
      p2: 'Po treningu smo se z Andreo še skupinsko in individualno fotografirali, klub pa je doživel še prav posebno čast: Andrea je prinesla tudi olimpijsko medaljo, ki so jo naši člani lahko prijeli, si jo ogledali od blizu in se z njo fotografirali. To je bil trenutek ponosa, navdiha in dodatne motivacije za vse generacije.',
      quote: '"To je bil trenutek ponosa, navdiha in dodatne motivacije za vse generacije."',
      p3: 'Ob tem pomembnem obisku pa klub praznuje tudi velik razvojni uspeh. Na javnem razpisu smo bili uspešni in podpisali novo pogodbo, s katero smo pridobili projekt, namenjen mladim, njihovim staršem ter širši javnosti. Gre za pomemben korak naprej, ki bo okrepil naše delo v lokalnem okolju in ustvaril nove priložnosti za športno udejstvovanje, povezovanje in zdrav življenjski slog.',
      p4: 'Zvečer smo izvedli še delovni sestanek projektne ekipe, kjer smo začrtali nadaljnje korake in simbolično nazdravili uspešni prihodnosti kluba ter trenerju, ki bo projekt vodil. Vsi člani kluba mu bomo pri izvedbi stali ob strani, pomagali in poskrbeli, da bo projekt dosegel svoj namen.',
      closing: 'Hvala, Andrea, za obisk, znanje in navdih – takšni dnevi gradijo prihodnost našega kluba!',
      cta: 'Oglej si vse fotografije',
    },
    news2: {
      title: 'Na Pokalu Bežigrad smo bili srebrni',
      p1: 'Obe naši državni prvakinji v kategoriji mlajših deklic sta osvojili odlično drugo mesto: Jora Kuci in Diana Černec.',
      p2: 'Velik uspeh naše judo športne šole je pri mlajših kadetih dopolnil tudi Luka Angelini, ki je prav tako osvojil drugo mesto. Trenutno je na točkovnem mestu vseh tekmovanj pri ml. kadetih, si Luka skupaj z Galom Purnatom deli drugo mesto. Tudi Gal je na isti tekmi dosegel drugo mesto, zato oba ostajata v samem vrhu in si še naprej delita vodilni položaj.',
      p3: 'Ostali zasledovalci niso bili tako uspešni, zato sta se Luka in Gal točkovno od njih še nekoliko oddaljila. To pomeni, da imata ob koncu rang lestvice lepo možnost, da dosežeta najmanj tisti cilj, ki smo si ga zadali — uvrstitev vsaj na drugo mesto.',
      quote: '"To je dober veter, morda za zdaj še rahla sapica, ki pa kaže, da se naša judo športna šola ponovno dviga in da znova dosegamo rezultate, kakršne smo nekoč že ustvarjali."',
      p4: 'Vsem tekmovalcem, ki so dosegli lepe uvrstitve, iskreno čestitamo za njihov uspeh.',
      caption: 'Na slikah: Diana in Jora na podelitvi medalj - medalje je podeljevala OI šampionka Andreja Leški. Tretja slika: Jora v borbi z nasprotnico.',
      cta: 'Oglej si vse fotografije',
    },
    about: {
      label: 'O klubu',
      titleTop: 'Judo šola',
      titleGold: 'Iztoka Babiča',
      text: 'Naša šola zajema delo v Izoli, Kopru in Ankaranu – povezujemo tri klube z isto vizijo odličnosti. Tradicija, disciplina in prijateljstvo so temelji našega dela.',
      cta: 'Več o nas',
    },
    enrollTeaser: {
      label: 'Vpis 2026–2027',
      title: 'Vpiši svojega otroka v judo',
      text: 'Odpiramo vpis v judo športno šolo za dečke in deklice. Preveri urnik treningov in se nam pridruži v telovadnici OŠ Dante Alighieri v Izoli.',
      cta: 'Poglej urnik in vpis',
    },
    cta: {
      title: 'Postani del naše zgodbe',
      text: 'Pridruži se našemu klubu in začni svojo pot v svetu juda. Sprejemamo člane vseh starosti in izkušenj.',
      button: 'Kontaktiraj nas',
    },
  },
  galerija: {
    hero: {
      label: 'Galerija',
      title: 'Foto utrinki',
      sub: 'Trenutki, ki jih hranimo. Treningi, tekmovanja in dogodki, ki gradijo našo zgodbo.',
    },
    photosWord: 'fotografij',
    open: 'Odpri galerijo',
    moreSoon: 'Več dogodkov kmalu...',
    close: 'Zapri',
    prev: 'Prejšnja',
    next: 'Naslednja',
    events: {
      'poletje-na-tatamiju-2026': {
        title: 'Poletje na tatamiju – 16 dni juda v Izoli',
        description: 'Dva poletna judo kampa, obisk olimpijske prvakinje Andreje Leški, prvi ženski črni pas v klubu in intervju za RTV Slovenija.',
        photos: [
          { title: 'Andreja Leški na tatamiju', description: 'Olimpijska prvakinja Andreja Leški med treningom mlajših judoistov na kampu' },
          { title: 'Poln tatami mladih judoistov', description: 'Trening mlajših starostnih skupin na poletnem judo kampu' },
          { title: 'Intervju za RTV Slovenija', description: 'Naš mladi član v pogovoru z novinarko RTV Slovenija' },
          { title: 'Pred kamero', description: 'Snemanje televizijskega prispevka o poletnem judo kampu' },
          { title: 'Skupinska fotografija z Andrejo Leški', description: 'Naši mladi člani z olimpijsko prvakinjo in predsednikom kluba' },
          { title: 'Polaganje mojstrskega izpita', description: 'Polaganje izpita za mojstrsko stopnjo pred komisijo' },
          { title: 'Nina Jajić – 1. DAN', description: 'Trener Jaša Babič in Nina Jajić z diplomo za črni pas – prva ženska mojstrica juda v našem klubu' },
        ],
      },
      'andreja-in-ekipa-2026': {
        title: 'Andreja Leški in naša ekipa',
        description: 'Utrinki z olimpijsko prvakinjo Andrejo Leški in našo ekipo s poletnega judo kampa v Areni Bonifika.',
        photos: [
          { title: 'Andreja in naša ekipa', description: 'Naši najmlajši člani z olimpijsko prvakinjo Andrejo Leški' },
          { title: 'Diana in Andreja pri demonstraciji', description: 'Naša Diana kot partnerka olimpijske prvakinje pri prikazu tehnike' },
          { title: 'Poletni judo kamp Izola', description: 'Skupni pozdrav udeležencev kampa v Areni Bonifika' },
          { title: 'Jaka pri fizioterapiji', description: 'Jaka je v kampu potreboval fizioterapevtsko oskrbo – tudi za to je poskrbljeno' },
        ],
      },
      'pokal-bezigrad-2024': {
        title: 'Pokal Bežigrad 2024 - Srebrni uspeh',
        description: 'Na Pokalu Bežigrad smo bili srebrni. Naše državne prvakinje in mladi kadeti so dosegli odlične rezultate.',
        photos: [
          { title: 'Podelitev medalj', description: 'Diana in Jora na podelitvi medalj - medalje je podeljevala OI šampionka Andreja Leški' },
          { title: 'Zmagovalke na odru', description: 'Naši mladi judoisti na zmagovalnem odru' },
          { title: 'Jora v borbi', description: 'Jora Kuci v borbi z nasprotnico' },
        ],
      },
      'andrea-leski-2024': {
        title: 'Olimpijska prvakinja Andrea Leški v Judo klubu Izola',
        description: 'Trening, ki ga ne pozabiš! Olimpijska prvakinja Andrea Leški je obiskala naš klub.',
        photos: [
          { title: 'Nadzor vadbe', description: 'Andrea Leški nadzoruje vadbo članov' },
          { title: 'Demonstracija vtopa z izravnoteženjem', description: 'Andrea Leški prikazuje tehniko' },
          { title: 'Demonstracija prijema', description: 'Prikaz judo prijema' },
          { title: 'Uspešen primer izravnoteženja', description: 'Andrea prikazuje izravnoteženje' },
          { title: 'Skupina mlajših judoistov', description: 'Naši mladi judoisti po treningu' },
          { title: 'Nazdravili k uspehu novega projekta', description: 'Praznovanje uspešnega projekta namenjenega mladim športnikom' },
        ],
      },
    },
  },
  kontakt: {
    hero: {
      label: 'Kontakt',
      title: 'Stopite v stik',
      sub: 'Imate vprašanja? Želite izvedeti več o članstvu? Kontaktirajte nas.',
    },
    infoTitle: 'Kontaktni podatki',
    address: { title: 'Naslov', value: 'Osnovna šola Dante Alighieri, Izola' },
    phone: { title: 'Telefon', value: '+386 31 625 170', note: 'Iztok Babič' },
    email: { title: 'E-pošta', value: 'iztok.babic8@gmail.com', note: 'Iztok Babič' },
    hours: { title: 'Urnik treningov', value: 'Torek in četrtek: 16.30–20.00 • Sreda in petek: 16.30–17.30' },
    locationsTitle: 'Naše lokacije',
    locations: [
      { name: 'Izola', note: 'Telovadnica OŠ Dante Alighieri – treningi in vpis' },
      { name: 'Koper', note: 'Podrobnosti bodo dodane' },
      { name: 'Ankaran', note: 'Podrobnosti bodo dodane' },
    ],
    map: { title: 'Zemljevid', text: 'Osnovna šola Dante Alighieri, Izola' },
    google: {
      label: 'Google',
      title: 'Najdete nas na Googlu',
      text: 'Poiščite Judo klub Izola na Google Zemljevidih, si oglejte lokacijo in nam pustite oceno. Vaše mnenje nam veliko pomeni.',
      cta: 'Odpri v Googlu',
    },
    schedule: {
      label: 'Urnik',
      title: 'Tedenski urnik vadbe',
      text: 'Urnik treningov za vse skupine – vrtec, mlajši, starejši ter veterani in rekreacija – v telovadnici OŠ Dante Alighieri.',
      imgAlt: 'Tedenski urnik treningov Judo kluba Izola za vse skupine',
    },
    enroll: {
      label: 'Vpis 2026–2027',
      title: 'Judo športna šola za dečke in deklice',
      intro: 'Vabimo k vpisu v judo športno šolo za sezono 2026–2027. Treningi in vpis potekajo v telovadnici OŠ Dante Alighieri.',
      rows: [
        { group: 'Učenci/ke 1–2 r. OŠ', days: 'Torek in četrtek', time: '16.30–18.00' },
        { group: 'Učenci/ke 3–5 r. OŠ', days: 'Torek in četrtek', time: '18.00–20.00' },
        { group: 'Judo vrtec', days: 'Sreda in petek', time: '16.30–17.30' },
      ],
      note: 'Pri vpisu se lahko dogovorimo tudi za druge termine vadbe.',
      posterAlt: 'Plakat vpisa v judo športno šolo 2026–2027',
    },
    school: {
      label: 'Judo šola',
      title: 'Judo šola Iztoka Babiča',
      text: 'Naša šola deluje v treh lokacijah: Izola, Koper in Ankaran. Povezujemo tri klube z isto vizijo odličnosti in tradicijo vrhunskega juda.',
    },
  },
  kampi: {
    hero: {
      label: 'Kampi in prireditve',
      title: 'Kampi, tekmovanja in prireditve',
      sub: 'Poletni judo kampi, mednarodno povezovanje in prihajajoče prireditve Judo kluba Izola.',
    },
    event: {
      badge: 'Napoved dogodka',
      title: 'Evropski mladinski judo pokal',
      date: 'Konec novembra 2026',
      place: 'Arena Bonifika, Koper',
      text: 'Judo klub Izola in Judo klub Impol skupaj sodelujeta pri organizaciji evropskega mladinskega judo pokala v Areni Bonifika. Podrobnejša najava s promocijo sledi kmalu.',
      soon: 'Promocija v pripravi',
    },
    cta: {
      title: 'Se nam želite pridružiti?',
      text: 'Kontaktirajte nas za več informacij o kampih, treningih in prireditvah.',
      button: 'Kontaktiraj nas',
    },
  },
  strokovna: {
    hero: {
      label: 'Strokovna znanja',
      title: 'Znanje, ki gradi šampione',
      sub: 'Predavanja, strokovni članki in zgodovinski pogledi trenerja Iztoka Babiča.',
    },
    video: {
      label: 'Predavanje',
      title: 'Izsek s predavanja pred predstavniki JZS (2011)',
      desc: 'O prečasnosti (anticipaciji) ter primerjava z borbeno akcijo. Trener Iztok Babič predstavlja strokovni pogled na predvidevanje in odzivnost v judu.',
    },
    docsLabel: 'Zgodovinske teme',
    docsTitle: 'Dve zgodovinski temi',
    docs: [
      {
        title: 'Sodobni zgodovinski pogledi na tekmovalno filozofijo športa',
        desc: 'Razvoj tekmovalnega športa in njegove filozofije z vidika juda – od antičnih korenin do sodobnih pojavov ter pomena juda za razvoj mladih. (Avtor: Iztok Babič)',
        meta: '9 strani · PDF',
        cta: 'Preberi članek',
      },
      {
        title: 'Mladi športniki v antičnih olimpijskih igrah',
        desc: 'Vloga mladih športnikov v antičnih olimpijskih igrah in primerjava z današnjimi olimpijskimi igrami mladih ter vplivom politike na šport.',
        meta: '4 strani · PDF',
        cta: 'Preberi članek',
      },
    ],
    note: 'Strokovna gradiva bomo redno dopolnjevali.',
  },
  onas: {
    hero: {
      label: 'Judo Klub Izola',
      title: 'O nas',
      sub: 'Zgodba predanosti, znanja in razvoja',
    },
    beginnings: {
      label: 'Začetki',
      title: 'Prvi slikovni materiali, ki nakazujejo začetke, se najdejo že v strokovni literaturi',
      p1: 'Judo klub Izola, takrat še pod imenom Športno društvo Vitalis, je začel delovati leta 1998. Tega leta so odprli Osnovno šolo z italijanskim učnim jezikom Dante Alighieri, iste jeseni pa so začeli z vpisom novincev v judo.',
      imgCaption: 'Slike iz knjige Judo za mlade, sezona 1999/2000',
      p2: 'Tako se je začela druga šolska sezona, 1999/2000.',
      p3: 'Obe zgornji sliki sta bili objavljeni v knjigi Judo za mlade, ki je bila pripravljena že leta 2000, izšla pa leto kasneje, leta 2001. To pomeni, da so bili otroci fotografirani v sezoni 1999/2000, dogajanje pa je potekalo v telovadnici omenjene šole. Na desni strani je trener Iztok Babič – na zgornji sliki v pripravi na predstavitev, na spodnji pa med predstavitvijo klubskega tekmovanja pred prvimi gledalci, to je starši, v prilagojeni judo/sumo borbi za najmlajše.',
      p4: 'Tako je zgodovina juda v Izoli že v prvih letih zabeležena tudi v literaturi, kjer trener kot avtor sporoča, da je borba pomembna za razvoj že pri zelo rosnih letih, če je seveda pedagoško prilagojena otrokovi starosti. To je v knjigi zelo dobro predstavljeno.',
    },
    recognition: {
      label: 'Priznanje',
      title: 'Prizadevanje za priznanje Judo kluba Izola kot športne šole nacionalnega pomena',
      p: [
        'Trener Iztok Babič je bil sofinanciran v okviru zgoraj navedenega projekta preko Judo kluba 15. maj Marezige in si je prizadeval, da bi ta program zajel vse judo klube, ki jih je organiziral. Še posebej pomembno je bilo to za Judo klub Izola, ki je v tem programu sodeloval.',
        'Zato je na Ministrstvo za šolstvo in šport, s katerim je imel podpisano pogodbo, naslovil dopis, da bi se mu delo v drugem klubu ne le priznalo, temveč tudi formalno uredilo zaradi določila o konkurenčni klavzuli, da to delo ne bi bilo sporno. Na ta dopis je prejel skromen, vendar pozitiven odgovor.',
        'Lahko rečemo, da je bilo s tem Judo klubu Izola priznano delo z mladimi, tudi z nadarjenimi mladimi člani. To je sicer pomenilo določeno prestižnost, vendar je bilo bistveno predvsem to, da je šlo za priznanje kakovostnega in strokovno nespornega dela.',
      ],
      imgCaption: 'Odgovor ministrstva na dopis, s katerim je bilo dovoljeno strokovno delo v okviru Športne šole nacionalnega pomena.',
    },
    literature: {
      label: 'Literatura',
      title: 'Za uspeh je bila potrebna bogata literatura – Izašla je prva knjiga',
      capCover: 'Judo za mlade – naslovnica knjige iz leta 2001.',
      capPages: 'Judo za mlade – notranja vsebina, tudi slike.',
      p: [
        'Knjigo sta sofinancirala Ministrstvo za šolstvo in šport ter Fundacija za šport Republike Slovenije. Da je ministrstvo sofinanciralo takšno knjigo, je bilo zelo redko. Če pa pomislimo, da so leta 1996 pri Judo zvezi predlagali vključitev juda v šolska športna tekmovanja in želeli, da to vodi Iztok Babič, je to lahko eden izmed razlogov, zakaj so njegovo delo podprli.',
        'To pa še ni bilo vse. Zveza je bila seznanjena tudi s tem, da je bil leta 1997 sprejet kot trener v Športno šolo nacionalnega pomena. Vse to zgovorno kaže, da je bil trener s svojim delom opažen že prej in da so mu bile s strani države ponujene možnosti za strokovno delo z mladimi v judu. Kmalu zatem je izšla tudi literatura, ki jo danes predstavljamo.',
      ],
      bold: 'To pa še ni konec. V nadaljevanju na kratko predstavljamo napredek, katerega krona je bila osvojena olimpijska zlata medalja v Parizu 2024, ki jo je osvojila Andreja Leški, vpisana v Športno šolo Iztoka Babiča jeseni 2002.',
    },
    book2: {
      label: 'Nadaljevanje',
      title: 'Nato je prišla druga knjiga',
      imgCaption: 'Knjiga, izdana leta 2010: zgoraj njena naslovnica in zadnja platnica, spodaj pa njena vsebina.',
      p: [
        'Druga knjiga se vsebinsko naslanja na prvo knjigo Judo za mlade, pri čemer skuša na praktičnem prikazu Evropskega kadetskega prvenstva 2009, ki je bilo v Areni Bonifika v Kopru, pokazati nadaljnji razvoj strokovnega dela.',
        'Sporočilo je dvojno oziroma lahko rečemo, da sloni na dveh pomembnih stebrih. Prvič: od prijaznih začetnih pedagoških pristopov pri športnih tekmovanjih najmlajših v klubski organizaciji do največjih vrhunskih tekmovanj mladostnikov. Trener je torej evropska tekmovanja pripeljal domov in jih preučeval tako rekoč na lastnem pragu.',
        'Drugič: vso strokovno znanost, ki je bila na voljo v knjižnicah, vse strokovne članke z laboratorijskimi raziskavami in njihovimi ugotovitvami, je trener povezal v nov koncept razlage prakse. Poleg tega je razvijal tudi metode, kako na podlagi teh spoznanj vplivati na še učinkovitejši razvoj mladega človeka v športnem treniranju.',
      ],
      youthCaption: 'Izolski mladostniki 2007: skrajno desno kleče Andreja Leški, za njo stoje pa njena stalna spremljevalka na tekmovanjih Lea Knez.',
    },
    kata: {
      label: 'Judo kate',
      title: 'Andreja Leški in Lea Knez - judo kata nastop l. 2011',
      kataCaption: 'Andreja Leški in Lea Knez - judo kata nastop l. 2011.',
      p: [
        'Športna šola Iztoka Babiča je na treninge uvajala tudi judo kate. Na tem področju smo bili pionirji razvoja, kar je vključevalo udeležbo na mednarodnih srečanjih in seminarjih, organizacijo mednarodnih tekmovanj, državnih prvenstev in celo dveh evropskih prvenstev, leta 2013 in 2017, na OŠ Koper.',
        'Leta 2012 je Igor Albreht, ki je ta program vodil, v Pragi dosegel 3. mesto, trener Iztok Babič pa je prevzel zastavo kot naslednji organizator.',
      ],
      flagCaption: 'Prevzem zastave v Pragi 2012 na EP judo kat, kot naslednji organizator v l. 2013.',
    },
    lectures: {
      label: 'Izobraževanje',
      title: 'Redna predavanja',
      imgCaption: 'Redna predavanja za starše in mladostnike so potekala v telovadnici OŠ Dante Alighieri leta 2022.',
    },
    camps: {
      label: 'Judo kampi',
      title: 'Poletni judo kampi v Izoli',
      intro: [
        'Že več kot 30 let redno poteka Poletni judo kamp Izola pod pokroviteljstvom Judo zveze Slovenije, pri katerem je imel Judo klub Izola kot domači klub pomembno organizacijsko vlogo.',
        'Z leti se je razvil tudi redni družinski poletni kamp judoistov iz Dunaja. Od leta 2024 dalje pa poteka še tretji Poletni TC judo kamp Izola v organizaciji Judo kluba Izola.',
      ],
      campCaption: 'Izobraževanje je potekalo v vseh judo kampih v Izoli – slika je s telovadnice OŠ D. Alighieri. Na sliki prvi z desne Slavko Obadov, prvi judoist, ki je za Jugoslavijo osvojil medaljo na OI in sicer l. 1976 v Montreal (Kanada).',
      p1: 'V kampih, kjer sodelujejo praktično vse starostne skupine, velja posebej poudariti, da med člani prihajajo tudi najelitnejši judoisti iz vse Evrope, med njimi številni dobitniki olimpijskih medalj, tudi zlatih. Omenimo samo enega – Ilias Iliadisa, ki je osvojil zlate medalje na največjih tekmovanjih. Avgusta 2013 je bil pri nas, konec istega meseca pa je ob izteku kariere osvojil še zadnjo medaljo z velikih tekmovanj, in sicer bronasto medaljo na svetovnem prvenstvu v Riu de Janeiru v Braziliji.',
      livadeCaption: 'Poletni judo kamp Izola 2023 v dvorani OŠ Livade, ki so ga redno obiskovali vsi mladi judoisti z Obale. Na drugi sliki pa smo trenirali tudi z olimpijskim prvakom Ilio Iliadisom.',
    },
    tatami: {
      label: 'Poletje na tatamiju',
      title: 'Izola – več kot 30 let judo kampov, izobraževanja, prijateljstva in vrhunskega športa',
      intro: [
        'Letošnje poletje je znova potrdilo pomembno mesto Izole na zemljevidu slovenskega in mednarodnega juda. Z dvema zaporednima judo kampoma smo ustvarili kar 16 dni intenzivnega športnega treniranja, izobraževanja, druženja in mednarodnega povezovanja.',
        'Toda zgodba izoljskih judo kampov je veliko daljša. Nastajala je več kot tri desetletja in skozi čas prerasla okvir običajnih športnih priprav. Kampi so postali tudi pomemben prostor izobraževanja, kjer se znanje in izkušnje prenašajo med trenerji, tekmovalci in generacijami.',
        'Mladi se tukaj ne učijo samo tehnik in borbe. Učijo se ob starejših in izkušenejših, spoznavajo različne načine treniranja, pridobivajo nove izkušnje ter znanje postopoma nadgrajujejo. Hkrati se izobražujejo tudi trenerji, saj mednarodno okolje omogoča izmenjavo strokovnih pogledov, metod dela in dobrih praks.',
        'Prav izobraževanje in neprekinjen prenos znanja sta bila skozi več kot trideset let pomembna gradnika razvoja mladih športnikov. Nadarjeni in vztrajni so postopoma napredovali od mlajših kategorij do mladinskega in članskega juda, nekateri pa vse do evropskih, svetovnih in olimpijskih medalj.',
        'Zato naših kampov ne razumemo samo kot športne priprave. So prostor športnega treniranja in izobraževanja, medgeneracijskega prenosa znanja, prijateljstva ter mednarodnega povezovanja. Prav preplet vseh teh dejavnosti je ustvaril okolje, v katerem so lahko mladi skozi leta napredovali in dosegali tudi najvišje športne cilje.',
      ],
      s1: {
        title: 'Prvi kamp – več kot 30 let tradicije in mednarodnega povezovanja',
        p: [
          'Prvi mednarodni judo kamp skupaj vodita Judo klub Izola in Judo klub Impol. Njegova posebnost je več kot tridesetletna tradicija, v kateri so pomembno vlogo odigrali tudi številni tuji klubi. Nekateri se v Izolo vračajo že več kot tri desetletja.',
          'Pri razvoju te zgodbe je pomembno vlogo odigral domači Judo klub Izola, ki je skozi leta skrbel, da se znanje in izkušnje starejših trenerjev in tekmovalcev niso izgubili, temveč so se prenašali na nove generacije.',
          'Mladi so trenirali ob starejših in uspešnejših tekmovalcih, jih opazovali, se od njih učili ter jih sčasoma skušali dohiteti in tudi preseči. Najbolj nadarjeni, vztrajni in uspešni so napredovali v mladinske in članske kategorije, nekateri pa vse do največjih mednarodnih tekmovanj.',
          'Tako je kamp skozi desetletja postal pomemben gradnik športnega treniranja in izobraževanja mladih.',
        ],
      },
      s2: {
        title: 'Znanje prve generacije se ne izgubi – nova ga prevzema in nadgrajuje',
        p: [
          'Posebna vrednost več kot tridesetletne tradicije je prav v tem, da se pridobljeno znanje s prihodom novih generacij ne izgubi.',
          'Prve generacije trenerjev in tekmovalcev so skozi dolgoletno delo pridobivale izkušnje, razvijale načine treniranja in svoje znanje prenašale na mlajše. Ti so ga prevzemali, bogatili z lastnimi izkušnjami in novimi strokovnimi spoznanji ter ga nato predajali naprej.',
          'Tako se je oblikovala neprekinjena razvojna veriga: ena generacija postavlja temelje, naslednja jih prevzame, nadgradi in razvija naprej.',
          'Mladi, ki so se nekoč na kampih učili od starejših, so pozneje sami postajali vrhunski tekmovalci, trenerji in vzorniki naslednjim generacijam.',
        ],
        quote: 'Prav v tem vidimo eno največjih vrednosti našega sistema: novo ne izniči starega, ampak iz njega raste in ga nadgrajuje.',
      },
      s3: {
        title: 'Prijateljstvo in mednarodna izmenjava znanja',
        p: [
          'Kampi pa skozi desetletja niso povezovali samo generacij, ampak tudi ljudi iz različnih držav.',
          'V Izoli so skupaj trenirali športniki iz Slovenije, Italije, Kosova, Poljske in številnih drugih okolij. Trenerji so izmenjevali strokovna spoznanja, metode dela in dobre prakse, tekmovalci pa so dobivali nove partnerje ter spoznavali različne načine juda.',
          'Ob tem so nastajala prijateljstva, ki so pogosto trajala veliko dlje od posameznega kampa. Prav dejstvo, da se nekateri tuji klubi v Izolo vračajo že več kot trideset let, najbolje kaže, da se je iz športnega sodelovanja razvila prava mednarodna skupnost.',
          'Znanja nismo zadrževali zase. Izmenjevali smo ga, se učili drug od drugega in si mednarodno pomagali napredovati.',
          'Tudi zaradi tega je izolski kamp skozi desetletja postal prepoznaven v širšem evropskem judo prostoru.',
        ],
      },
      s4: {
        title: 'Od mladih udeležencev do olimpijskih medalj',
        p: [
          'Rezultati takšnega dela se ne pokažejo čez noč.',
          'Za vrhunskim športnikom stojijo leta dela v matičnem klubu, trenerji, reprezentančni programi, tekmovanja in številni drugi dejavniki. Kamp pa je lahko pomemben del tega procesa, saj športniku ponudi drugačne partnerje, nova znanja, nove izkušnje in primerjavo z najboljšimi.',
          'V več kot treh desetletjih so številni športniki, ki so se izpopolnjevali tudi na naših kampih, pozneje osvajali medalje na evropskih in svetovnih prvenstvih ter olimpijskih igrah.',
          'Še posebej smo ponosni na našo obalno olimpijsko prvakinjo Andrejo Leški, ki je leta 2024 v Parizu osvojila zlato olimpijsko medaljo.',
          'Njena pot ima za naše mlade posebno sporočilo: kaže jim, da lahko otrok, ki danes stopi na tatami na slovenski Obali, s talentom, vztrajnostjo, kakovostnim treningom in pravim strokovnim okoljem nekoč pride tudi do največjih športnih dosežkov.',
        ],
      },
      s5: {
        title: 'Drugi kamp – nova generacija nadaljuje zgodbo',
        p: [
          'To kontinuiteto je lepo pokazal tudi drugi letošnji kamp, ki ga je organizirala Judo zveza Slovenije.',
          'Program je zajemal članske in mladinske borbene treninge, delo z mlajšimi starostnimi kategorijami ter učenje kat in priprave na izpite za mojstrske stopnje.',
          'Tudi tukaj se je pokazalo, kako pomembno je povezovanje generacij. Mladi danes pridobivajo znanje od vrhunskih tekmovalcev in trenerjev, ti pa nadaljujejo proces, ki so ga pred desetletji začele prejšnje generacije. Tako se izkušnje preteklosti povezujejo s sodobnimi pristopi športnega treniranja.',
          'Prva dva dneva je mlajše judoiste vodila Kaja Kajzer, dvakratna evropska podprvakinja, v nadaljevanju pa olimpijska prvakinja Andreja Leški.',
          'Na kampu so aktivno sodelovali tudi naši mladi člani Judo kluba Izola. Zanje je bila to dragocena športna in izobraževalna izkušnja, saj so lahko neposredno trenirali ob vrhunskih športnicah, jih opazovali, poslušali njihove nasvete ter pridobivali nova znanja.',
          'Poseben trenutek je bilo srečanje z Andrejo Leški, s katero so se naši mladi člani tudi fotografirali.',
        ],
        imgCaption: 'Naši mladi člani z olimpijsko prvakinjo Andrejo Leški.',
        after: 'Ta fotografija lepo simbolizira bistvo naših kampov: danes se mladi učijo od olimpijske prvakinje, jutri pa bodo morda prav oni svoje znanje in izkušnje predajali naslednji generaciji.',
      },
      s6: {
        title: 'Pomemben uspeh Nine Jajić',
        p: [
          'Pomemben izobraževalni del kampa so predstavljale tudi priprave na izpite za mojstrske stopnje.',
          'Poseben uspeh je dosegla Nina Jajić, ki je uspešno opravila izpit za 1. DAN – črni pas ter tako iz šolskih prestopila v mojstrske stopnje juda.',
        ],
        bold: 'S tem je postala prva ženska mojstrica juda v našem klubu.',
        quote: 'Nina, iskrene čestitke!',
        cap1: 'Polaganje izpita za mojstrsko stopnjo pred komisijo.',
        cap2: 'Trener Jaša Babič in Nina Jajić z diplomo za 1. DAN – črni pas.',
        after: 'Tudi njen uspeh potrjuje, da judo kamp ni samo prostor borbenega treninga, ampak tudi prostor širšega judo izobraževanja, tehničnega izpopolnjevanja in osebnega razvoja.',
      },
      s7: {
        title: '16 dni juda in potreba po nadaljnjem razvoju',
        p: [
          'Z letošnjima kampoma se je obdobje organiziranih poletnih judo aktivnosti v Izoli z nekdanjih enajstih povečalo na kar 16 dni.',
          'Več udeležencev, več treningov in več mednarodnega sodelovanja pa pomeni tudi potrebo po boljših pogojih.',
          'Zato smo se povezani klubi odločili za vlaganje v novo opremo in dodatne tatamije. Sedanjih približno 700 kvadratnih metrov vadbene površine želimo povečati na približno 1.000 kvadratnih metrov.',
          'Del sredstev smo že zbrali sami, pri nadaljnjem razvoju pa želimo k sodelovanju povabiti tudi širšo javnost in vse, ki prepoznavajo pomen vlaganja v šport in mladino.',
        ],
        bold: 'To ni samo naložba v nove blazine. Je naložba v več prostora za otroke, več kakovostnega treninga, več izobraževanja, več mednarodnih povezav in več možnosti za prihodnje generacije.',
      },
      s8: {
        title: 'Znanje širimo na celotno slovensko Obalo',
        p: [
          'Naše delo želimo v prihodnje še bolj razširiti in povezati celotno slovensko Obalo.',
          'Sodelovanje in delo Judo kluba Izola in Judo kluba Ankaran omogočata, da znanje in izkušnje, ki so nastajali skozi desetletja, prenašamo tudi v druga okolja.',
          'Naš cilj ni zapirati znanja znotraj posameznega kluba. Nasprotno – želimo ga širiti, oplemenititi in ustvarjati možnosti za otroke v Izoli, Ankaranu, Kopru in drugod na Obali.',
          'Koper že ima olimpijsko prvakinjo Andrejo Leški. Naša želja pa je, da bi z dobrim strokovnim delom in sodelovanjem ustvarjali pogoje, da bi v prihodnosti vrhunski športniki lahko prihajali tudi iz Izole, Ankarana in drugih obalnih okolij.',
          'Ne gre za tekmovanje med občinami, katera bo dobila naslednjega olimpijskega prvaka. Gre za nekaj pomembnejšega: da celotna Obala postane okolje, v katerem imajo mladi možnost razviti svoj talent do najvišje ravni.',
          'Vsaka prihodnja evropska, svetovna ali olimpijska medalja z naše Obale bo zato uspeh širšega okolja, ki je mlademu športniku omogočilo razvoj.',
        ],
      },
      s9: {
        title: 'Po kampih nas čaka še evropski mladinski pokal',
        p: [
          'Z zaključkom poletnih kampov pa naše skupno delo še zdaleč ni končano.',
          'Čaka nas še en lep in pomemben del letošnje judo zgodbe.',
          'Judo klub Izola in Judo klub Impol bosta konec novembra skupaj sodelovala pri organizaciji evropskega mladinskega judo pokala v Areni Bonifika v Kopru.',
          'To je pomembno tudi zato, ker ponovno kaže moč sodelovanja obeh klubov. Sodelovanje, ki ga gradimo na kampih, se nadaljuje pri organizaciji velikega mednarodnega tekmovanja.',
          'Od dela z otroki in mladimi, preko kampov in izobraževanja tako prihajamo do evropskega tekmovalnega prostora.',
          'Posebno simboliko ima tudi prizorišče. Prav v tem okolju je trenirala Andreja Leški. Borilnica, v kateri se je pripravljala aktualna olimpijska prvakinja, bo ob evropskem pokalu ponovno del športnega dogajanja. Mladi tekmovalci se bodo tam pripravljali in ogrevali, nato pa stopili na tekmovalni prostor Arene Bonifika.',
          'Ob fotografiji tega prostora lahko zato upravičeno zapišemo:',
        ],
        quote: '»V tej borilnici je trenirala aktualna olimpijska prvakinja Andreja Leški.«',
        after: [
          'Za mladega športnika je to lahko močno sporočilo. Na istem prostoru, kjer se danes pripravlja na svojo borbo, je nekoč trenirala športnica, ki je pozneje osvojila olimpijsko zlato.',
          'Tudi evropski mladinski pokal bo zato nadaljevanje tistega, kar že več kot tri desetletja gradimo na naših kampih: izobraževanje, športno treniranje, mednarodno sodelovanje, prijateljstvo in prenos znanja na mlade.',
        ],
      },
      s10: {
        title: 'Najpomembnejši ostajajo otroci in prihodnje generacije',
        p1: 'Ko govorimo o olimpijskih medaljah, velikih mednarodnih tekmovanjih, 1.000 kvadratnih metrih tatamija in več kot tridesetletni tradiciji, ne smemo pozabiti, zaradi koga vse to počnemo.',
        bold: 'Zaradi otrok in mladih.',
        p: [
          'Na fotografijah letošnjih kampov vidimo otroke, ki danes šele začenjajo svojo športno pot. Ob njih stojijo starejši tekmovalci, trenerji, evropski dobitniki medalj in olimpijska prvakinja.',
          'Pred desetletji so bili na njihovem mestu neki drugi otroci. Nekateri so pozneje postali vrhunski športniki in osvojili evropske, svetovne in olimpijske medalje.',
          'Danes je pred nami nova generacija.',
          'Naša odgovornost je, da ji zagotovimo znanje, kakovosten trening, izobraževanje, dobre pogoje, mednarodne izkušnje, prijateljstvo in možnost napredovanja.',
          'Zato povezujemo klube, generacije in občine. Zato širimo prostor za trening. Zato organiziramo kampe in mednarodna tekmovanja. In zato znanje, ki smo ga pridobivali več kot trideset let, predajamo naprej.',
          'Ne moremo vedeti, kateri otrok bo nekoč postal vrhunski športnik. Lahko pa ustvarimo okolje, v katerem bo vsak dobil možnost razviti svoje sposobnosti.',
          'Morda je prav med otroki, ki danes trenirajo na naših blazinah in se fotografirajo z olimpijsko prvakinjo, nekdo, ki bo nekoč osvojil naslednjo evropsko, svetovno ali olimpijsko medaljo.',
          'Takrat to ne bo samo uspeh enega športnika, enega kluba ali ene občine. To bo uspeh vseh, ki smo znanje ohranjali, ga razvijali, delili in prenašali iz generacije v generacijo.',
        ],
        quote: 'To je zgodba naših judo kampov – zgodba več kot tridesetih let znanja, izobraževanja, prijateljstva in sodelovanja ter hkrati zgodba prihodnosti juda na celotni slovenski Obali.',
      },
    },
    today: {
      label: 'Sedanjost',
      title: 'Judo danes',
      cap1: 'Starejša skupina mladostnikov.',
      cap2: 'Skupina vseh mlajših in starejših judoistov (manjkajo le naši najmlajši člani).',
    },
    future: {
      label: 'Prihodnost',
      title: 'Judo jutri',
      p1: 'Programi, ki jih sprejemamo, so nadaljevanje dosedanjega dela, kateremu dodajamo aktualne teme kot nadgradnjo. Te novosti so posledica našega stalnega napredovanja in potreb, ki jih zaznavamo v okolju.',
      bold: 'Omenimo le nekatere nove vsebine:',
      plans: {
        lectures: {
          title: 'Predavanja',
          items: [
            'Staršem bomo osvetlili, kako pripraviti učence, da bodo bolj učinkovito usklajevali šolo in športno treniranje.',
            'Prehrana športnika',
            'Športno treniranje – strokovne članke že pišemo, prve smo tudi že objavili',
            'Športna tekmovanja – posebej za začetnike in tudi za tiste, ki imajo manj znanja',
          ],
        },
        cooperation: {
          title: 'Sodelovanje',
          text: 'Več bomo sodelovali z vrtci, šolami in učitelji športne vzgoje.',
        },
        education: {
          title: 'Izobraževanje',
          text: 'Postopno pripravljamo pravi izobraževalni center na Obali. Kaže se potreba po večji integraciji vseh nas na Obali, po tesnejšem sodelovanju in po razvojni mreži, ki bi vključevala tudi druge strokovnjake ter njihova znanja.',
        },
      },
    },
    trainers: {
      label: 'Vodstvo',
      title: 'Naši trenerji',
      fb: 'Facebook profil',
      iztok: {
        name: 'Iztok Babič',
        role: 'profesor športne vzgoje in Mentor športnega treniranja',
        desc: 'Pedagoški vodja judo športne šole – s klubom ima sklenjeno volontersko pogodbo.',
      },
      jasa: {
        name: 'Jaša Babič',
        role: 'diplomant športnega treniranja (UN)',
        desc: 'Glavni trener – pogodbeno zaposlen pri Judo klubu Izola s polnim delavnim časom.',
      },
      mojmir: {
        name: 'Mojmir Kovač',
        role: 'trener 2. stopnje',
        desc: 'Zunanji strokovni delavec – s klubom ima sklenjeno volontersko pogodbo.',
      },
      oleksander: {
        name: 'Oleksander Makhovsky',
        role: 'pomočnik trenerja',
      },
    },
    recognition2: {
      label: 'Priznanje',
      title: 'Strokovni kader Judo športne šole Iztoka Babiča je pripeljal do izjemne predstavitve in priznanja',
      cap1: 'Predstavitev na Evropskem kadetskem pokalu Koper 2024: olimpijske prvakinje Andreje Leški in njenega prvega trenerja Iztoka Babiča.',
      cap2: 'Mladi člani so olimpijski šampionki Andreji Leški na evropskem pokalu svečano podelili šopek rož.',
      cap3: 'Andreja Leški je svojemu nekdanjemu trenerju Iztoku Babiču podelila plaketo, darilo Evropske judo zveze.',
      cap4: 'Plaketa z vsemi evropskimi imeni dobitnikov medalj, ki so osvojili medaljo na OI Pariz 2024.',
    },
    social: {
      fbKlub: 'Judo klub Izola na Facebooku',
      fbIztok: 'Iztok Babič na Facebooku',
    },
    cta: {
      titleBefore: 'Začni svojo ',
      titleGold: 'judo pot',
      text: 'Kontaktiraj nas za več informacij o članstvu in urnikih treningov.',
      button: 'Kontaktiraj nas',
    },
  },
};

export default sl;
